import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Home, Building2, Plus, BookOpen, User, Shield } from "lucide-react";
import { TrialBanner } from "@/components/TrialBanner";
import { useSeo } from "@/lib/seo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Home", icon: Home, end: true },
  { to: "/dashboard/properties", label: "Strutture", icon: Building2 },
  { to: "/dashboard/guides", label: "Guide", icon: BookOpen },
  { to: "/dashboard/settings", label: "Profilo", icon: User },
];

export default function DashboardLayout() {
  const navigate = useNavigate();
  const loc = useLocation();
  const { user } = useAuth();
  const hideNav = loc.pathname.includes("/properties/new") || loc.pathname.includes("/import") || loc.pathname.includes("/review");
  useSeo({ noindex: true });

  return (
    <div className="min-h-screen bg-slate-50 max-w-md mx-auto relative shadow-sm">
      {user?.role === "admin" && !hideNav && (
        <NavLink to="/dashboard/admin" data-testid="nav-admin-link"
          className="flex items-center justify-center gap-2 bg-slate-900 text-white text-xs font-semibold py-2">
          <Shield className="w-3.5 h-3.5" /> Pannello Admin
        </NavLink>
      )}
      {!hideNav && <TrialBanner />}
      <div className="pb-28"><Outlet /></div>

      {!hideNav && (
        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-slate-100 z-30" style={{ paddingBottom: "env(safe-area-inset-bottom)", boxShadow: "0 -4px 20px -8px rgba(15,23,42,0.12)" }}>
          <div className="grid grid-cols-5 items-center px-2 pt-1.5">
            {NAV.slice(0, 2).map((n) => <NavItem key={n.to} n={n} />)}
            <div className="flex justify-center">
              <button onClick={() => navigate("/dashboard/properties/new")} data-testid="nav-create" className="w-14 h-14 -mt-6 rounded-2xl bg-blue-500 text-white grid place-items-center shadow-lg shadow-blue-500/30 active:scale-95 transition-transform">
                <Plus className="w-7 h-7" strokeWidth={2.6} />
              </button>
            </div>
            {NAV.slice(2).map((n) => <NavItem key={n.to} n={n} />)}
          </div>
        </nav>
      )}
    </div>
  );
}

const NavItem = ({ n }) => (
  <NavLink to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase()}`}
    className={({ isActive }) => `flex flex-col items-center gap-0.5 py-1.5 transition-colors ${isActive ? "text-blue-600" : "text-slate-400"}`}>
    <n.icon className="w-[22px] h-[22px]" /><span className="text-[10px] font-semibold">{n.label}</span>
  </NavLink>
);
